module.exports = __webpack_public_path__ + "static/img/bg_ptzx_nei.8989f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_ptzx_nei.png
// module id = j+9J
// module chunks = 19